import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "@/components/motion/Reveal";
import { CtaButton } from "@/components/brand/CtaButton";

export const ImageFeature = ({ image, alt, eyebrow, title, text, actions = [], reverse = false, tone = "light", testid = "image-feature" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const dark = tone === "dark";

  return (
    <section ref={ref} className={`py-20 sm:py-28 ${dark ? "bg-ink" : "bg-ivory"}`} data-testid={testid}>
      <div className="shell grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className={`lg:col-span-6 ${reverse ? "lg:order-2" : ""}`}>
          <div className="relative h-[340px] overflow-hidden rounded-[28px] sm:h-[460px] lg:h-[540px]">
            <motion.img src={image} alt={alt} loading="lazy" style={{ y }} className="absolute inset-0 h-[118%] w-full -translate-y-[8%] object-cover" />
            <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-tr from-plum/40 via-transparent to-transparent" />
          </div>
        </Reveal>
        <div className="lg:col-span-6">
          {eyebrow && <Reveal as="p" className={`eyebrow ${dark ? "text-gold" : "text-plum-2"}`}>{eyebrow}</Reveal>}
          <Reveal as="h2" delay={0.05} className={`mt-6 font-display text-[2.1rem] font-light leading-[1.06] tracking-[-0.02em] sm:text-5xl ${dark ? "text-white" : "text-ink"}`}>
            {title}
          </Reveal>
          <Reveal delay={0.1} className={`mt-6 space-y-4 text-base leading-relaxed md:text-lg ${dark ? "text-white/75" : "text-ink/75"}`}>
            {Array.isArray(text) ? text.map((t) => <p key={t}>{t}</p>) : <p>{text}</p>}
          </Reveal>
          {actions.length > 0 && (
            <Reveal delay={0.15} className="mt-10 flex flex-col gap-3 sm:flex-row">
              {actions.map((a) => (
                <CtaButton key={a.label} to={a.to} variant={a.variant || (dark ? "gold" : "plum")} testid={a.testid}>{a.label}</CtaButton>
              ))}
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};
